// src/helpers/settings/users.ts
var pinAlreadyExistsCore = (pin, currentOrganizationUserId, state, userEmail) => {
  let isPinExistent = false;
  const organizationUsers = state.settings.master.users;
  let user;
  const isUserCreationMode = currentOrganizationUserId === 0;
  for (user of Object.values(organizationUsers)) {
    if (user.pin !== pin)
      continue;
    if (!isUserCreationMode && currentOrganizationUserId !== user.organizationUserId) {
      isPinExistent = true;
      break;
    }
    if (isUserCreationMode && userEmail !== user.user.email) {
      isPinExistent = true;
      break;
    }
  }
  return isPinExistent;
};
var generateUniqueUserPinCore = (state) => {
  let isPinUnique = false;
  let newPin = "";
  const organizationUsers = state.settings.master.users;
  const currentPins = Object.values(organizationUsers).map(
    (user) => user.pin
  );
  while (!isPinUnique) {
    const _newPin = Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 10)
    ).join("");
    if (!currentPins.includes(_newPin)) {
      isPinUnique = true;
      newPin = _newPin;
    }
  }
  return newPin;
};

export { generateUniqueUserPinCore, pinAlreadyExistsCore };
